module.exports = __webpack_public_path__ + "img/svg/step1.ba30d63dcf5fb5463ccc7fd93129bf83.svg";